var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHint = function SvgHint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    viewBox: "0 0 40.124 40.124"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.938 12.141c1.856 0 2.971.99 2.971 2.66 0 3.033-5.414 3.869-5.414 7.55 0 .99.648 2.072 1.979 2.072 2.042 0 1.795-1.516 2.538-2.6.989-1.453 5.6-3 5.6-7.023 0-4.361-3.897-6.188-7.858-6.188-3.773 0-7.24 2.692-7.24 5.725 0 1.237.929 1.887 2.012 1.887 2.999.001 1.453-4.083 5.412-4.083M22.135 28.973c0-1.393-1.145-2.537-2.537-2.537s-2.537 1.146-2.537 2.537c0 1.393 1.145 2.537 2.537 2.537s2.537-1.144 2.537-2.537"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.124 20.062C40.124 9 31.124 0 20.062 0S0 9 0 20.062s9 20.062 20.062 20.062 20.062-8.999 20.062-20.062M2 20.062C2 10.103 10.103 2 20.062 2s18.062 8.103 18.062 18.062-8.103 18.062-18.062 18.062S2 30.021 2 20.062"
  })));
};
export default SvgHint;